export const IntegrationType = {
  XERO: 'Xero',
} as const;
export type IntegrationType = (typeof IntegrationType)[keyof typeof IntegrationType];
